import { render, staticRenderFns } from "./newsxq.vue?vue&type=template&id=c5156bfe&scoped=true&"
import script from "./newsxq.vue?vue&type=script&lang=js&"
export * from "./newsxq.vue?vue&type=script&lang=js&"
import style0 from "./newsxq.vue?vue&type=style&index=0&id=c5156bfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5156bfe",
  null
  
)

export default component.exports